import * as Sentry from '@sentry/angular';

/** Subset of `environment` needed for Sentry. */
export interface SentryEnvConfig {
  production: boolean;
  sentryDsn: string;
}

/**
 * Do not set `tracePropagationTargets` to backend origins (apiUrl, authUrl, …): Sentry injects
 * `sentry-trace` and `baggage` on matching requests, which requires those header names in the
 * API’s CORS `Access-Control-Allow-Headers`. Without backend support, the browser reports CORS errors.
 *
 * Omitting `tracePropagationTargets` uses SDK defaults (typically same-origin / localhost only), so
 * SPA → cross-origin gateway calls stay unchanged while router/pageload tracing still works.
 */
export function initSentryFromEnvironment(env: SentryEnvConfig, options: { release?: string } = {}): void {
  const dsn = env.sentryDsn?.trim();
  if (!dsn) {
    return;
  }

  Sentry.init({
    dsn,
    environment: env.production ? 'production' : 'development',
    ...(options.release ? { release: options.release } : {}),
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: env.production ? 0.2 : 1.0,
  });
}

export function isSentryEnabled(env: SentryEnvConfig): boolean {
  return Boolean(env.sentryDsn?.trim());
}
